import { render, staticRenderFns } from "./list.vue?vue&type=template&id=07abcf20&lang=pug"
import script from "./list.vue?vue&type=script&lang=coffee"
export * from "./list.vue?vue&type=script&lang=coffee"
import style0 from "./list.vue?vue&type=style&index=0&id=07abcf20&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksCommons: require('/opt/build/repo/site/components/globals/blocks/commons.coffee').default})
